import React, {FC} from 'react';

import {RendererOf} from '../../../../../../../libs/shared/core/src/helpers/react/reactHelpers';
import {useTagBulkActionPermission} from '../../../../../../../srcCommon/permissions/useBulkActionPermission';
import {BulkActionTypesEnum} from '../../../../../../helpers/bulkActionHelpers';
import {PermissionResult} from '../../../../../../helpers/permissionHelpers';
import {InboxesParameters} from '../../../../../../store/panels/inboxes/parameters/inboxesParameters';
import {BulkActionCoordinator} from '../bulk/bulkActionCoordinator';

/*
 * Props.
 */

interface ConversationsStarCoordinatorProps {
  onStar: () => void;
  onUnstar: () => void;
  onBulkStar: () => void;
  onBulkUnstar: () => void;
  areAllStarred: boolean;
  isBulkActionRequired: boolean;
  inboxesParameters: InboxesParameters;

  renderButton: RendererOf<ConversationsStarButtonProps>;
}

export interface ConversationsStarButtonProps {
  onClick: () => void;
  areAllStarred: boolean;
  permissionResult: PermissionResult;
}

/*
 * Component.
 */

export const ConversationsStarCoordinator: FC<ConversationsStarCoordinatorProps> = (props) => {
  const {areAllStarred, inboxesParameters, isBulkActionRequired} = props;
  const bulkActionPermission = useTagBulkActionPermission(isBulkActionRequired, inboxesParameters);
  if (areAllStarred) {
    return (
      <BulkActionCoordinator
        onBulkAction={props.onBulkUnstar}
        onNormalAction={props.onUnstar}
        actionType={BulkActionTypesEnum.UNSTAR}
        shouldPerformBulkAction={isBulkActionRequired}
      >
        {(onAction) =>
          props.renderButton({
            onClick: onAction,
            areAllStarred: true,
            permissionResult: bulkActionPermission,
          })
        }
      </BulkActionCoordinator>
    );
  }

  return (
    <BulkActionCoordinator
      onBulkAction={props.onBulkStar}
      onNormalAction={props.onStar}
      actionType={BulkActionTypesEnum.STAR}
      shouldPerformBulkAction={isBulkActionRequired}
    >
      {(onAction) =>
        props.renderButton({
          onClick: onAction,
          areAllStarred: false,
          permissionResult: bulkActionPermission,
        })
      }
    </BulkActionCoordinator>
  );
};
